import React from "react";
import { StoriesList } from "./StoryDetail";

export default function Stories() {
  return <StoriesList />;
}
